import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import {
  getSignatureFileName,
  Signature,
  SignatureCreate
} from "src/app/backend/models/signature/signature";
import { HTTP_CONTEXT_TOKEN_NO_SWAP_DEEP_PROPERTY_ID } from "src/app/core/http-context-tokens";
import { UserNotify } from "src/app/support/notify-decorator";
import { omitFalsyProperties } from "src/app/support/object";
import { environment } from "src/environments/environment";

@Injectable()
export class EnigmaBackend {
  private readonly http = inject(HttpClient);

  loadSignature(id: string): Observable<Signature> {
    return this.http.get<Signature>(
      `${environment.snoots.api.enigma}/signatures/${id}`
    );
  }

  createSignature(payload: SignatureCreate): Observable<Signature> {
    return this.http.post<Signature>(
      `${environment.snoots.api.enigma}/signatures`,
      payload,
      {
        context: new HttpContext().set(
          HTTP_CONTEXT_TOKEN_NO_SWAP_DEEP_PROPERTY_ID,
          true
        )
      }
    );
  }

  @UserNotify({
    successMessage: marker("OTP inviato"),
    errorMessage: marker("Non è stato possibile inviare l'OTP")
  })
  sendOtpSignature({
    signatureId,
    transport,
    phone,
    email,
    signedById,
    signedByName,
    storageIds
  }: {
    signatureId: string;
    transport: "sms" | "email";
    phone?: string;
    email?: string;
    signedById?: string;
    signedByName?: string;
    storageIds?: string[];
  }): Observable<void> {
    const newAttachments = storageIds?.map((storageId) => ({
      contentType: "application/pdf",
      fileName: getSignatureFileName(),
      storageId
    }));

    return this.http.put<void>(
      `${environment.snoots.api.enigma}/signatures/${signatureId}/send-otp`,
      omitFalsyProperties({
        transport,
        phone,
        email,
        signedBy:
          !!signedById || !!signedByName
            ? omitFalsyProperties({
                id: signedById,
                name: signedByName
              })
            : undefined,
        attachments: newAttachments
      }),
      {
        context: new HttpContext().set(
          HTTP_CONTEXT_TOKEN_NO_SWAP_DEEP_PROPERTY_ID,
          true
        )
      }
    );
  }

  completeSignature({
    signatureId,
    otp
  }: {
    signatureId: string;
    otp: string;
  }): Observable<void> {
    return this.http.put<void>(
      `${environment.snoots.api.enigma}/signatures/${signatureId}/complete`,
      { otp }
    );
  }
}
